import { render, staticRenderFns } from "./add-goal.vue?vue&type=template&id=6bf9de25&scoped=true&"
import script from "./add-goal.vue?vue&type=script&lang=js&"
export * from "./add-goal.vue?vue&type=script&lang=js&"
import style0 from "./add-goal.vue?vue&type=style&index=0&id=6bf9de25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf9de25",
  null
  
)

export default component.exports